var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"pointer",attrs:{"src":"/assets/img/edit.png","alt":"update tax","width":"25px"},on:{"click":_vm.openAddServiceCategory}}),_c('AddServiceModal',{attrs:{"id":_vm.service.id,"closeModal":_vm.closeModal,"service":_vm.service,"category":_vm.category,"countryList":_vm.countryList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }